import React, { useEffect } from "react";
import './IndustriesWeServe.css';
import { Link, useLocation } from "react-router-dom";

const IndustriesWeServe = () => {


    const location = useLocation();

    useEffect(() => {
        if (location.hash) {
            const element = document.getElementById(location.hash.replace('#', ''));
            if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }
    }, [location]);

    return (
        <div className="Industry-Container">
            <div className={"Industry-Main-Container"}>
                
                <h1 className="Industry-Page-Heading">
                    With over four decades of expertise in Salt, Minerals, and Chemicals,
                    <strong>Chemi-Salt Corporation</strong> has become a trusted sourcing partner for a wide range of
                    industries across South Gujarat and beyond. Our product portfolio is tailored to meet the specific
                    needs of sectors such as <strong>Paints, Food Processing, Soaps & Detergents, Textiles, Chemicals,
                        and Plastics</strong> — where purity, consistency, and supply reliability are critical.
                    Whether it's supplying high-purity salt for food and pharmaceutical use, specialty minerals for paint formulation, or industrial-grade
                    chemicals for large-scale manufacturing, we understand the unique requirements of each industry and deliver products that align with their
                    standards and processes. Our long-standing client relationships are built on quality assurance, competitive pricing, and timely service — making
                    us a dependable partner in your supply chain.

                </h1>

                <div  className="Industry-Row-Align" id="paint">
                    <h1 className={"Industry-Title"}>Paint Industry</h1>
                    <div className="Industry-Product-Container">
                        <Link to="/contactus" className="productCard">
                            <h3>Talc Powder</h3>
                        </Link>
                        <Link to="/contactus" className="productCard">
                            <h3>Dolomite</h3>
                        </Link>
                        <div className="productCard">
                            <h3>Calcite</h3>
                        </div>
                    </div>
                    <div className="Industry-Product-Container">
                        <div className="productCard">
                            <h3>Titanium Di-Oxides</h3>
                        </div>
                        <div className="productCard">
                            <h3>China Clay</h3>
                        </div>
                        <div className="productCard">
                            <h3>Speciality Chemicals</h3>
                        </div>
                    </div>
                </div>


                <Link to="/contactus" className="Industry-Row-Align" id="food">

                    <h1 className={"Industry-Title"}>Food Industry</h1>

                    <div className="Industry-Product-Container">
                        <div className="productCard">
                            <h3>Iodized Salt</h3>
                        </div>
                        <div className="productCard">
                            <h3>Black Salt (Rock Salt)</h3>
                        </div>
                        <div className="productCard">
                            <h3>Starch Powder</h3>
                        </div>
                    </div>
                    <div className="Industry-Product-Container-2">
                        <div className="productCard">
                            <h3>Hydrated Lime</h3>
                        </div>
                        <div className="productCard">
                            <h3>Citric Acid</h3>
                        </div>
                    </div>



                </Link>


                <Link to="/contactus" className="Industry-Row-Align" id="textile">
                    <h1 className={"Industry-Title"}>Textile Industry</h1>
                    <div className="Industry-Product-Container">
                        <div className="productCard">
                            <h3>Soda Ash Light</h3>
                        </div>
                        <div className="productCard">
                            <h3>Hydrogen Peroxide</h3>
                        </div>
                        <div className="productCard">
                            <h3>Sodium Sulphate</h3>
                        </div>
                    </div>

                    <div className="Industry-Product-Container">
                        <div className="productCard">
                            <h3>Caustic Soda Flakes / Liquid</h3>
                        </div>
                        <div className="productCard">
                            <h3>Salts (Refined and Fine)</h3>
                        </div>
                        <div className="productCard">
                            <h3>Dyes, Reactive Dyes and Acid Dyes</h3>
                        </div>
                    </div>

                    <div className="Industry-Product-Container">
                        <div className="productCard">
                            <h3>Hydrated Lime</h3>
                        </div>
                        <div className="productCard">
                            <h3>Sodiun Hypo Chlorite</h3>
                        </div>
                        <div className="productCard">
                            <h3>Bleaching Powder</h3>
                        </div>
                    </div>

                    <div className="Industry-Product-Container-3">
                        <div className="productCard">
                            <h3>Citric Acid, Starch Powder</h3>
                        </div>
                    </div>
                </Link>


                <Link to="/contactus" className="Industry-Row-Align" id="plastic">
                    <h1 className={"Industry-Title"}>Plastic Industry</h1>

                    <div className="Industry-Product-Container">
                        <div className="productCard">
                            <h3>Talc Powder</h3>
                        </div>
                        <div className="productCard">
                            <h3>Calcium Carbonate</h3>
                        </div>
                        <div className="productCard">
                            <h3>Calcite 2 Microns / 5 Microns</h3>
                        </div>
                    </div>
                    <div className="Industry-Product-Container-2">
                        <div className="productCard">
                            <h3>Dolomite</h3>
                        </div>
                        <div className="productCard">
                            <h3>Quartz Powder</h3>
                        </div>
                    </div>


                </Link>


                <Link to="/contactus" className="Industry-Row-Align" id="chemical">
                    <h1 className={"Industry-Title"}>Chemical Industry</h1>
                    <div className="Industry-Product-Container">
                        <div className="productCard">
                            <h3>Soda</h3>
                        </div>
                        <div className="productCard">
                            <h3>Caustic</h3>
                        </div>
                        <div className="productCard">
                            <h3>Sodium Sulphate</h3>
                        </div>
                    </div>
                    <div className="Industry-Product-Container">
                        <div className="productCard">
                            <h3>HCL</h3>
                        </div>
                        <div className="productCard">
                            <h3>Nitric Acid</h3>
                        </div>
                        <div className="productCard">
                            <h3>Sulphuric Acid</h3>
                        </div>
                    </div>
                    <div className="Industry-Product-Container-2">
                        <div className="productCard">
                            <h3>Salts</h3>
                        </div>
                        <div className="productCard">
                            <h3>Hydrogen Peroxide</h3>
                        </div>
                    </div>
                </Link>


                <Link to="/contactus" className="Industry-Row-Align" id="soap">
                    <h1 className={"Industry-Title"}>Soap Industry</h1>
                    <div className="Industry-Product-Container">
                        <div className="productCard">
                            <h3>Salts</h3>
                        </div>
                        <div className="productCard">
                            <h3>Dolomite</h3>
                        </div>
                        <div className="productCard">
                            <h3>Soda Ash Light</h3>
                        </div>
                    </div>
                    <div className="Industry-Product-Container">
                        <div className="productCard">
                            <h3>Acid</h3>
                        </div>
                        <div className="productCard">
                            <h3>China Clay</h3>
                        </div>
                        <div className="productCard">
                            <h3>AOS Liquid</h3>
                        </div>
                    </div>
                    <div className="Industry-Product-Container">
                        <div className="productCard">
                            <h3>SIES Powder / Liquid</h3>
                        </div>
                        <div className="productCard">
                            <h3>Colored Speckles</h3>
                        </div>
                        <div className="productCard">
                            <h3>Needles</h3>
                        </div>
                    </div>
                    <div className="Industry-Product-Container-3">
                        <div className="productCard">
                            <h3>Perfumes</h3>
                        </div>

                    </div>

                </Link>


            </div>
        </div>
    );
};

export default IndustriesWeServe;
